import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=014a4049&"
import script from "./TV.vue?vue&type=script&lang=js&"
export * from "./TV.vue?vue&type=script&lang=js&"
import style0 from "./TV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports